export const SET_HRES4AX_INDEX_DISP = 'SET_HRES4AX_INDEX_DISP'
export const GET_HRES4AX_INDEX_DISP = 'GET_HRES4AX_INDEX_DISP'
export const SET_HRES4AX_DETAIL_DISP = 'SET_HRES4AX_DETAIL_DISP'
export const GET_HRES4AX_DETAIL_DISP = 'GET_HRES4AX_DETAIL_DISP'
export const SET_HRES4AX_COLUMNS = 'SET_HRES4AX_COLUMNS'
export const GET_HRES4AX_COLUMNS = 'GET_HRES4AX_COLUMNS'
export const SET_HRES4AX_LABELS = 'SET_HRES4AX_LABELS'
export const GET_HRES4AX_LABELS = 'GET_HRES4AX_LABELS'
export const RECEIVED_HRES4AX_COLUMNS_LABELS = 'RECEIVED_HRES4AX_COLUMNS_LABELS'
export const SET_HRES4AX_INDEX = 'SET_HRES4AX_INDEX'
export const GET_HRES4AX_INDEX = 'GET_HRES4AX_INDEX'
export const RECEIVED_HRES4AX_INDEX = 'RECEIVED_HRES4AX_INDEX'
export const SET_HRES4AX_INDEX_SELECTED = 'SET_HRES4AX_INDEX_SELECTED'
export const GET_HRES4AX_INDEX_SELECTED = 'GET_HRES4AX_INDEX_SELECTED'
export const SET_HRES4AX_DETAIL = 'SET_HRES4AX_DETAIL'
export const GET_HRES4AX_DETAIL = 'GET_HRES4AX_DETAIL'
export const RECEIVED_HRES4AX_DETAIL = 'RECEIVED_HRES4AX_DETAIL'
export const SET_HRES4AX_POPUP1 = 'SET_HRES4AX_POPUP1'
export const GET_HRES4AX_POPUP1 = 'GET_HRES4AX_POPUP1'
export const RECEIVED_HRES4AX_POPUP1 = 'RECEIVED_HRES4AX_POPUP1'
export const SET_HRES4AX_POPUP2 = 'SET_HRES4AX_POPUP2'
export const GET_HRES4AX_POPUP2 = 'GET_HRES4AX_POPUP2'
export const RECEIVED_HRES4AX_POPUP2 = 'RECEIVED_HRES4AX_POPUP2'
export const TOGGLE_HRES4AX_PAGE = 'TOGGLE_HRES4AX_PAGE'



// WEBPACK FOOTER //
// ./src/store/modules/hres4ax/mutation-types.js